module.exports = __webpack_public_path__ + "static/media/danger.a37c9703.svg";